<template>
    <v-app>
        <v-content>
            <elc-header v-if="isLogin"></elc-header>
            <router-view/>
            <elc-footer v-if="isLogin"></elc-footer>
        </v-content>
    </v-app>
</template>

<script>
    import ElcHeader from "./components/Common/ElcHeader";
    import ElcFooter from "./components/Common/ElcFooter";

    export default {
        name: 'App',
        components: {ElcFooter, ElcHeader},

        updated: function () {
            let self = this;
            let token = localStorage.getItem('token');
            if (token == '' || token == undefined || token == null) {
                self.isLogin = false;
                self.$router.push('/');
            }
            else {
                self.isLogin = true;
            }
        },
        created: function () {
            let self = this;
            let token = localStorage.getItem('token');
            if (token == '' || token == undefined || token == null) {
                self.isLogin = false;
                self.$router.push('/');
            }
            else {
                self.isLogin = true;
            }
        },
        data() {
            return {
                isLogin: false,
            }
        },

    }
</script>
<style>
    .v-small-dialog__content {
        background-color: #ffffff !important;
        padding: 15px;
    }

    .v-dialog, .v-dialog--active {
        background-color: rgba(0,0,0,0.4);
    }

    .success-toast.toasted.primary {
        background-color: #2c9d28 !important;
    }

    .error-toast.toasted.primary {
        background-color: #d61c16 !important;
    }

    .v-datatable thead th.column.sortable {
        cursor: pointer;
        outline: 0;
        padding: 8px;
        font-size: 12px;
    }

    .theme--light.v-datatable thead th.column.sortable i{
        font-size: 17px !important;
        padding: 0 5px;
    }

    .solid-border-1-b{
        border: 1px solid black;
    }
    .no-border{
        border: 0px solid black;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue